import * as THREE from 'three'
import Experience from "../Experience";
import Tableau1 from './Tableau1';
import Tableau2 from './Tableau2';
import Stats from 'stats.js'


export default class World {

    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        this.router = this.experience.router



        // this.premierTableau = new Tableau1({
        //     model: this.ressources.items.tableau1Model,
        //     modelTexture: this.ressources.items.tableau1Texture,
        // })
        this.tableau2 = new Tableau2({
            batiment: this.ressources.items.batiment,
        })



        this.experience.debug.active ? this.setStats() : null
        this.update()
        // this.testRenderer()


    }
    testRenderer() {
        function countMaterials(scene) {
            const materials = new Set();

            scene.traverse((child) => {
                if (child.isMesh) {
                    if (Array.isArray(child.material)) {
                        child.material.forEach((mat) => materials.add(mat));
                    } else {
                        materials.add(child.material);
                    }
                }
            });

            return materials.size;
        }
        console.log(this.experience.renderer.instance.info);
        console.log(countMaterials(this.scene))
        setTimeout(() => {
            this.tableau2.destroy()
            setTimeout(() => {
                console.log(this.experience.renderer.instance.info);
                console.log(countMaterials(this.scene))


            }, 3000)

        }, 3000)

    }

    setStats() {
        this.stats = new Stats()
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);
    }



    update() {
        if (this.premierTableau) {
            this.premierTableau.update()

        }
        if (this.tableau2) {
            this.tableau2.update()

        }
        if (this.stats) {
            // stats
            this.stats.begin();
            this.stats.end();
        }



    }

}